import React from "react";
import {
  Edit,
  SimpleForm,
  TextInput,
  required,
  SelectInput,
  SelectArrayInput,
} from "react-admin";
import zoneAlerts from "../../defaults/ZoneAlerts";
import WebhookContentTypes from "../../defaults/WebhookContentTypes";
import WebhookIntegrationTypes from "../../defaults/WebhookIntegrationTypes";
import OrgSelector from "../../components/OrgSelector";
import EventTypeSelector from "../../components/EventTypeSelector";

const WebhookEdit = (props) => {
  return (
    <Edit {...props} title="Edit Zone">
      <SimpleForm>
        <OrgSelector required />
        <TextInput
          fullWidth
          label="Destination"
          source="destination"
          validate={[required()]}
        />
        <TextInput fullWidth label="Delay" source="delay" />
        <SelectInput
          fullWidth
          label="Integration Type"
          source="integration_type"
          validate={[required()]}
          choices={WebhookIntegrationTypes}
        />
        <EventTypeSelector source="AlertTypes" label="Event Type" />
        <TextInput fullWidth label="Custom Fields" source="custom_fields" />
      </SimpleForm>
    </Edit>
  );
};

export default WebhookEdit;
